import * as t from './action_types.js';

const INITIAL_STATE = {
    name: '',
    data: null,
};

const routingReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.SET_ROUTE:
            const { name, data } = action.payload;
            return {
                ...state,
                name,
                data,
            };
        default:
            return state;
    }
};

export default routingReducer;
